import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { v4 as uuidv4 } from 'uuid';
import Store from '../../Store';
import IntroDialog, { Props } from '../_components/IntroDialog';
import { OnModuleAdd } from '../..//ModuleList/_actions/ModuleListActions';
import { ModuleOnMultipleValueUpdate } from '../../Module/_actions/ModuleActions';
import { ModuleTypes } from '../../Module/_config/ModuleInfo';
import { OnIntroOpen } from '../../Intro/_actions/IntroActions';

const mapStateToProps = (store:Store, props:Props) => ({
	opened: store.getIn(['create', 'intro', 'opened']),
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	addModule: (type:ModuleTypes) => {
		let id = uuidv4();
		dispatch(OnModuleAdd(id, type))
		return id;
	},
	updateModule: (moduleId:string, updates:{[key:string] : any}) => dispatch(ModuleOnMultipleValueUpdate(moduleId, updates)),
	setIntroOpen: (opened: boolean) => dispatch(OnIntroOpen(opened)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(IntroDialog);